import script from "./EmployeeView.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmployeeView.vue?vue&type=script&setup=true&lang=ts"

import "./EmployeeView.vue?vue&type=style&index=0&id=733e0c77&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-733e0c77"]])

export default __exports__